var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"89f4fd39523c21719d39170d673c8dc05ed1ba73"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["gawds-nextjs@omnicut"]={id:"89f4fd39523c21719d39170d673c8dc05ed1ba73"};
      